import { createTheme, MantineColorsTuple, rem } from '@mantine/core'

/**
 * Design tokens extracted from standinsurance.com/frontier:
 *
 * Fonts (from CSS custom properties):
 *   --sans:  "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif
 *   --serif: "Instrument Serif", "Iowan Old Style", Georgia, serif
 *   --mono:  "JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace
 *
 * Colors: dark editorial aesthetic — near-black backgrounds, white text,
 *         warm amber/gold accent, green for "safe", red for "loss"
 */

const standGold: MantineColorsTuple = [
  '#FFF9E6',
  '#FFF0BF',
  '#FFE699',
  '#FFD966',
  '#E6B84D',
  '#C9A043',
  '#A6843A',
  '#8C6E30',
  '#735A27',
  '#59451E',
]

const standDark: MantineColorsTuple = [
  '#C1C2C5',
  '#A6A7AB',
  '#909296',
  '#5C5F66',
  '#373A40',
  '#2C2E33',
  '#1A1B1E',
  '#141517',
  '#101113',
  '#0A0A0B',
]

export const theme = createTheme({
  primaryColor: 'stand-gold',
  colors: {
    'stand-gold': standGold,
    'stand-dark': standDark,
  },

  fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
  fontFamilyMonospace: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
  headings: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
    fontWeight: '600',
  },

  radius: {
    xs: rem(2),
    sm: rem(4),
    md: rem(8),
    lg: rem(12),
    xl: rem(16),
  },

  defaultRadius: 'md',

  spacing: {
    xs: rem(8),
    sm: rem(12),
    md: rem(16),
    lg: rem(24),
    xl: rem(32),
  },

  other: {
    fonts: {
      sans: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif',
      serif: '"Instrument Serif", "Iowan Old Style", Georgia, serif',
      mono: '"JetBrains Mono", ui-monospace, "SF Mono", Menlo, monospace',
    },
    brand: {
      gold: '#C9A043',
      goldLight: '#E6B84D',
      black: '#0A0A0B',
      surface: '#141517',
      surfaceLight: '#1A1B1E',
      border: '#2C2E33',
      textPrimary: '#FFFFFF',
      textSecondary: '#909296',
      textMuted: '#5C5F66',
      safe: '#4CAF50',
      danger: '#E53935',
      warning: '#FF9800',
    },
  },

  components: {
    Paper: {
      defaultProps: {
        bg: 'var(--mantine-color-stand-dark-7)',
      },
    },
    Button: {
      defaultProps: {
        radius: 'sm',
      },
    },
  },
})
